import { useSelector } from "metabase/lib/redux";
import { getUserIsAdmin } from "metabase/selectors/user";

import { shouldHideUpsells } from "../should-hide-upsells";

/**
 * we should wrap all upsell components in this HoC to ensure that they are only rendered for admins
 */
export function UpsellWrapper<Props extends object>(
  Component: React.ComponentType<Props>,
) {
  const WrappedComponent = (props: Props) => {
    const isAdmin = useSelector(getUserIsAdmin);

    if (shouldHideUpsells() || !isAdmin) {
      return null;
    }

    return <Component {...props} />;
  };

  return WrappedComponent;
}
